import { ScopeId } from "Store/Api/PropTypes";
import { StoreState } from "Store/Reducers";
import { getActionTypes } from "Store/Shared/Actions/Helpers";
import { API_URL } from "Store/Shared/Middleware/API/Constants";
import ACTIONS, { BLOCK_USER, FETCH_USER, FETCH_USERS_DATASET, FETCH_USER_PERMISSIONS, SAVE_USER_PERMISSIONS, UNBLOCK_USER, USER } from "./ActionTypes";

export const fetchUsers = () => {
    return {
        types: getActionTypes(ACTIONS.FETCH_USERS),
        shouldCallAPI: ({ users }: StoreState) => users._forceFetch,
        callAPI: {
            url: `/api/v2/users`
        }
    }
}

export const updateUser = (id: any, data: any) => {
    return {
        types: getActionTypes(ACTIONS.UPDATE_USER),
        callAPI: {
            method: 'PATCH',
            url: `/api/v2/users/${id}`,
            body: {
                ...data
            }
        }
    }
}

export function fetchUsersDataset() {
    return {
        types: [
            FETCH_USERS_DATASET.REQUEST,
            FETCH_USERS_DATASET.SUCCESS,
            FETCH_USERS_DATASET.FAILURE
        ],
        shouldCallAPI: ({users}: StoreState) => users.datasets._forceFetch,
        callAPI: (accessToken: any) => fetch(
            API_URL + '/api/users/dataset',
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function blockUser(id: any) {
    return {
        types: [
            BLOCK_USER.REQUEST,
            BLOCK_USER.SUCCESS,
            BLOCK_USER.FAILURE
        ],
        callAPI: (accessToken: any) => fetch(
            API_URL + `/users/${id}/block`,
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function unblockUser(id: any) {
    return {
        types: [
            UNBLOCK_USER.REQUEST,
            UNBLOCK_USER.SUCCESS,
            UNBLOCK_USER.FAILURE
        ],
        callAPI: (accessToken: any) => fetch(
            API_URL + `/users/${id}/unblock`,
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function fetchUserPermissions(id: any) {
    return {
        types: [
            FETCH_USER_PERMISSIONS.REQUEST,
            FETCH_USER_PERMISSIONS.SUCCESS,
            FETCH_USER_PERMISSIONS.FAILURE
        ],
        shouldCallAPI: (state: any) => (!state.users.users[id].permissions),
        callAPI: (accessToken: any) => fetch(
            API_URL + `/users/${id}/permissions`,
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function addUserPermission(user: any, scope_id: ScopeId) {
    return {
        type: USER.ADD_PERMISSION,
        payload: {
            id: user.id,
            scope: scope_id
        }
    }
}

export function deleteUserPermission(user: any, scope_id: ScopeId) {
    return {
        type: USER.DELETE_PERMISSION,
        payload: {
            id: user.id,
            scope: scope_id
        }
    }
}

export function resetUserPermission(user: any) {
    return {
        type: USER.RESET_PERMISSION,
        payload: {
            id: user.id
        }
    }
}

export function saveUserPermissions(id: any, permissions: any) {
    return {
        types: [
            SAVE_USER_PERMISSIONS.REQUEST,
            SAVE_USER_PERMISSIONS.SUCCESS,
            SAVE_USER_PERMISSIONS.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/users/${id}/permissions`,
            {
                method: 'PATCH',
                headers: {
                  Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(permissions)
            })
    }
}

export function fetchUser() {
    return {
        types: [
            FETCH_USER.REQUEST,
            FETCH_USER.SUCCESS,
            FETCH_USER.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + '/user',
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}